
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SwitchStatusResponse,
} from '../models';
import {
    SwitchStatusResponseFromJSON,
    SwitchStatusResponseToJSON,
} from '../models';

/**
 * 
 */
export class IndicesAdminApi extends runtime.BaseAPI {

    /**
     * Force switch alias
          */
    async forceSwitchRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/admin/indices/reindex-organizations/force-switch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Force switch alias
          */
    async forceSwitch(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.forceSwitchRaw(initOverrides);
    }

    /**
     * Get current organization index switch status information
          */
    async getOrganizationSwitchStatusRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SwitchStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SwitchStatusResponse>({
            path: `/client-settings/api/admin/indices/organization/switch-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SwitchStatusResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get current organization index switch status information
          */
    async getOrganizationSwitchStatus(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SwitchStatusResponse> {
        const response = await this.getOrganizationSwitchStatusRaw(initOverrides);
        return response._data;
    }

    /**
     * Trigger all organization indexation
          */
    async reindexOrganizationsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/admin/indices/reindex-organizations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Trigger all organization indexation
          */
    async reindexOrganizations(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexOrganizationsRaw(initOverrides);
    }

}
